import { useTranslation } from 'react-i18next';
import { formatDays } from '../../../utils/absenceDays';

interface WorkingDaysPreviewProps {
  workingDays: number | null;
  loading: boolean;
  /** Resturlaub vor diesem Antrag (nach offenen Anträgen); nur bei Typen, die auf den Urlaub zählen. */
  remainingVacation?: number | null;
}

/** Was der Antrag verbraucht: Arbeitstage laut AZM ohne Feiertage, optional der Resturlaub danach (FAFD-7). */
export function WorkingDaysPreview({ workingDays, loading, remainingVacation }: WorkingDaysPreviewProps) {
  const { t } = useTranslation('absences');

  if (loading && workingDays === null) {
    return <p className="text-[12px] text-slate-500">{t('form.workingDaysLoading')}</p>;
  }
  if (workingDays === null) return null;

  if (workingDays === 0) {
    return (
      <p className="text-[12px] text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
        {t('form.noWorkingDays')}
      </p>
    );
  }

  const after = remainingVacation != null ? remainingVacation - workingDays : null;
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-[12px] text-slate-700 tabular-nums">
      <span className="font-medium text-slate-900">
        {workingDays === 1
          ? t('form.workingDaysPreviewOne')
          : t('form.workingDaysPreview', { days: formatDays(workingDays) })}
      </span>
      {after != null && (
        <span className={after < 0 ? 'text-red-600' : 'text-slate-500'}>
          {' · '}
          {t('form.remainingAfter', { days: formatDays(after) })}
        </span>
      )}
    </div>
  );
}
